import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { DatasearchService } from '../../_services/datasearch.service';

@Component({
  selector: 'app-award-recognition',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgFor, NgIf, DatePipe],
  templateUrl: './award-recognition.component.html',
  styleUrl: './award-recognition.component.scss'
})
export class AwardRecognitionComponent {

  transparent = false;
  awards: any = [];
  head: any[] = [];
  currentPage: string = 'awards';
  awardBaseUrl = '';
  readMoreState: boolean[] = [];
  currentUrl: string;

  constructor(private datasearch_service: DatasearchService) {
    this.awardBaseUrl = this.datasearch_service.ApiUrl + '/uploads/awards/';
    this.readMoreState = this.awards.map(() => false);
    this.currentUrl = window.location.href; // Get the current URL
  }

  ngOnInit() {
    this.getCards();
    this.getHeading();
  }

  getCards() {
    this.datasearch_service.getAwards().subscribe((res) => {
      console.log('Awards API Response:', res);
      if (res.success && res.data) {
        let allAwards = [];
        if (Array.isArray(res.data)) {
          allAwards = res.data;
        } else if (res.data.awards) {
          allAwards = res.data.awards;
        } else {
          allAwards = res.data; // fallback
        }
        
        // Filter only active awards
        this.awards = allAwards.filter((award: any) => award.isActive === true);

        if (this.awards.length > 0) {
          console.log('First Award Keys:', Object.keys(this.awards[0]));
          console.log('First Award Image Value:', this.awards[0].award_image);
          console.log('Generated Image URL:', this.getAwardImageUrl(this.awards[0]));
        }
      }
    },
      (error) => {
        console.error('Error fetching awards:', error);
      })
  }

  getAwardWebLink(award: any): string {
    if (!award) return '';
    // Standard property names
    const possibleKeys = ['web_link', 'award_link', 'link', 'weblink', 'website', 'url', 'award_url', 'web_url', 'web_link_url'];
    for (const key of possibleKeys) {
      if (award[key] && award[key] !== 'null' && award[key] !== 'undefined') return String(award[key]).trim();
    }
    // Fallback: Smart search for anything link-related (avoiding images/logos)
    for (const key in award) {
      const k = key.toLowerCase();
      if ((k.includes('link') || k.includes('url') || k.includes('website'))
        && !k.includes('image') && !k.includes('logo') && !k.includes('poster') && !k.includes('thumb')) {
        const val = award[key];
        if (val && val !== 'null' && val !== 'undefined') return String(val).trim();
      }
    }
    return '';
  }

  getAwardImageUrl(award: any): string {
    const filename = award.award_image ||
      award.image ||
      award.logo ||
      award.award_logo ||
      award.award_logo_url ||
      award.award_banner ||
      award.poster ||
      award.thumbnail;

    if (!filename) {
      return 'https://www.chemrobotics.com/agropat/uploads/awards/placeholder.png';
    }

    const strFile = filename.toString();
    if (strFile.startsWith('http')) {
      return strFile;
    }

    // Clean leading slash and check if "uploads/" is already present anywhere in the path
    let cleanPath = strFile.replace(/^\//, '');
    if (!cleanPath.includes('uploads/')) {
      cleanPath = 'uploads/awards/' + cleanPath;
    }

    // Ensure accurate prefix (strip trailing slashes from ApiUrl)
    const baseUrl = this.datasearch_service.ApiUrl.replace(/\/$/, '');
    return `${baseUrl}/${cleanPath}`;
  }
  getHeading() {
    this.datasearch_service.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }
  toggleReadMore(index: number) {
    this.readMoreState[index] = !this.readMoreState[index];
  }
  openLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }
}
